import { type RootState } from '../../stores/redux';

export const getWaitingRoom = (state: RootState) => state.waitingRoom;
